export default __webpack_public_path__ + "static/media/RoslindaleDisplayCondensed-Medium.e8890248.otf";